import React, {useState, useEffect} from 'react';
import Breadcrumbs from './Breadcrumbs';






const Covidworld = () => {
  const [users, setUsers] = useState([]);
 
  const getUser = async () =>{
    //error halding
    try{
        const response = await fetch("https://api.covid19api.com/summary");
          
              const resJson = await response.json();
              // console.log(resJson);
              setUsers(resJson.Countries);
            
    }
    catch(error){
   console.log(error);

    }
   
}
useEffect(() => {
    getUser();

}, []);
  return (
        <>
        <Breadcrumbs name="Covid19 Update" linename="covid19"/>
        <section id="blog" className="blog">
      <div className="container">
  
        <div className="row">
     
            <table  className="table table-hover" style={{fontSize:"16px"}}>
                <thead className="thead-dark">
                    <tr>
                    <th>Country</th>
                    <th>Total Confirmed</th>
                    <th>Total Deaths</th>
                    <th>New Recovered</th>
                    <th>Total Recovered</th>
                    </tr>
                </thead>
                <tbody>
                {
                    users.map((curElen, ind)=>{
                        return(
                            <tr>
                    <td>{curElen.Country}</td>
                    <td>{curElen.TotalConfirmed}</td>
                    <td>{curElen.TotalDeaths}</td>
                    <td>{curElen.NewRecovered}</td>
                    <td>{curElen.TotalRecovered}</td>
                    </tr>
                        )

                    })
                }
                
                </tbody>
            </table>

        

     </div>

      </div>
    </section>
            
        </>
    )
}

export default Covidworld
